export default __webpack_public_path__ + "static/media/Version (7) - Snape Insult_02.db37dc64.jpg";